import branches from "../services/branches";
import estoreLocations from "../services/estore.locations";
import _ from "lodash";
import notification from "../services/notification";
import { getField, updateField } from "vuex-map-fields";
import router from "../router";

function formatToBrandsAndBranches(value) {
    const brandsAndBranches = [];
    const groupedByBrandName = _.groupBy(value, "brand_name");

    _.each(groupedByBrandName, (branches) => {
        const uuid = _.get(branches, "0.brand_uuid", null);
        const name = _.get(branches, "0.brand_name", null);

        if (uuid && name) {
            brandsAndBranches.push({
                uuid,
                name,
                branches
            });
        }
    });

    return _.orderBy(brandsAndBranches, [items => items.name.toLowerCase()]);
}

const mutations = {
    updateField,
    reset(state) {
        state.created = false;
        state.deleted = false;
        state.updated = false;
        state.imported = false;
        state.errors = {};
        state.loading = false;
    },
    branchOptions(state, data) {
        state.branchOptions = data;
    },
    branches(state, data) {
        let branches = {};
        let cities = [];
        let citiesByBrand = {};

        state.options = data;

        _.each(data, branch => {
            let brand = branch.brand_uuid;
            let city = branch.city;
            let brand_city = brand + "-" + branch.city;

            cities.push(city);
            if (!citiesByBrand[brand]) citiesByBrand[brand] = [];
            citiesByBrand[brand].push(city);

            if (!branches[brand_city]) branches[brand_city] = [];
            branches[brand_city].push(branch);
        });

        cities = _.uniq(cities);
        cities = _.sortBy(cities);

        state.branches = branches;
        state.cities = cities;
        state.citiesByBrand = _.each(citiesByBrand, (item, index) => {
            citiesByBrand[index] = _.sortBy(_.uniq(item));
        });
        state.loading = false;
    },
    loading(state, value) {
        state.loading = value;
        state.message = null;
    },
    errors(state, errors) {
        state.errors = errors;
    },
    created(state) {
        state.created = true;
    },
    updated(state) {
        state.updated = true;
    },
    deleted(state) {
        state.deleted = true;
    },
    view(state, data) {
        state.view = data;
        state.loading = false;
    },
    imported(state) {
        state.imported = true;
        state.loading = false;
    },
    setBranchTableList(state, branchTableList) {
        state.branchTableList = branchTableList;
    },
    setAdvanceSettings(state, advanceSettings) {
        state.advanceSettings = advanceSettings;
    },
    setOriginalFeatureBrand(state, originalFeatureBrand) {
        state.originalFeatureBrand = originalFeatureBrand;
    },
    setOriginalDeliveryBaseValue(state, deliveryBaseValue) {
        state.deliveryBaseValue = deliveryBaseValue;
    },
    getBrandUuid(state, brand_uuid) {
        state.brand_uuid = brand_uuid;
    },
    SET_SIMPLE_BRANCHES(state, branches) {
        state.branches = branches;
    },
    setOriginalBranches(state, payload) {
        state.originalBranches = payload;
    },
    setBrandsAndBranches(state, value) {
        state.brandsAndBranches = value;
    }
};

const getters = {
    getField,
    branchOptions: state => state.branchOptions,
    branches: state => state.branches,
    loading: state => state.loading,
    errors: state => state.errors,
    originalBranches: state => state.originalBranches,
    brandsAndBranches: state => state.brandsAndBranches
};

const actions = {
    async getBranches({ commit }, is_simple = false) {
        commit("loading", true);
        try {
            let response = await branches.getBranches();
            commit("setOriginalBranches", response);
            commit("branchOptions", response);

            if (is_simple) {
                commit("SET_SIMPLE_BRANCHES", response);
            } else {
                commit("branches", response);
                commit(
                    "setBrandsAndBranches", 
                    formatToBrandsAndBranches(response)
                );
            }
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async create({ commit, rootState }, payload) {
        commit("loading", true);
        try {
            let response = await branches.create(payload);

            // notification.success(branchTagged.message);
            const { enabledTopUps } = rootState.auth;
            if (
                Array.isArray(enabledTopUps) &&
                enabledTopUps.includes("estore")
            ) {
                let paramTaggedProducts = {
                    uuid: response.branch.brand_uuid,
                    payload: {
                        keyword: ""
                    }
                };

                let taggedProducts = await estoreLocations.getTaggedProducts(
                    paramTaggedProducts
                );

                let branchList = await estoreLocations.getBranchList(
                    paramTaggedProducts
                );

                let mappedBranches = branchList.map(branch => branch.uuid);

                let forAddProducts = taggedProducts.list.map(
                    taggedProduct => taggedProduct.uuid
                );

                let paramSaveTaggedProducts = {
                    for_add: forAddProducts,
                    for_delete: [],
                    branches: mappedBranches,
                    brand_uuid: paramTaggedProducts.uuid
                };

                // let branchTagged = await branches.tagProductsToBranch(response.branch.brand_uuid)
                await estoreLocations.addStoreBrandProducts(
                    paramSaveTaggedProducts
                );
            }

            notification.success(response.message);
            // notification.success(branchTagged.message);

            commit("created");
        } catch (errors) {
            notification.warning("Oops, cannot create new branch.");

            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async update({ commit }, payload) {
        commit("loading", true);
        try {
            let response = await branches.update(payload.uuid, payload);
            notification.success(response.message);
            commit("updated");
        } catch (errors) {
            notification.warning("Oops, cannot update branch.");
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async view({ commit }, uuid) {
        commit("loading", true);
        try {
            let response = await branches.view(uuid);
            commit("view", response);
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async delete({ commit }, uuid) {
        commit("loading", true);
        try {
            let response = await branches.delete(uuid);
            notification.success(response.message);
            commit("deleted", response);
        } catch (errors) {
            notification.error(errors.message);
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async importCSV({ commit }, file) {
        commit("loading");
        try {
            let response = await branches.importCSV(file);
            notification.success(response.message);
            commit("imported", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },
    async branchTableList({ commit }, payload) {
        commit("loading", true);
        try {
            let response = await branches.branchTableList(payload);
            commit("setBranchTableList", response.data);
            commit("reset");
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async branchTableCreate({ commit }, payload) {
        commit("loading", true);
        try {
            let response = await branches.branchTableCreate(payload);
            notification.success(response.message);
            commit("reset");
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async viewAdvanceSettings({ commit }, param) {
        commit("loading", true);
        try {
            let response = await branches.viewAdvanceSettings(
                param.uuid,
                param.payload
            );

            if (response.data.delivery_base_km == null) {
                response.data.delivery_base_km = 0;
            }

            if (response.data.delivery_base_km_range == null) {
                response.data.delivery_base_km_range = 0;
            }

            if (response.data.delivery_base_value == null) {
                response.data.delivery_base_value = 0;
            }

            if (response.data.deliver_now == 1) {
                response.data.deliver_now = true;
            } else {
                response.data.deliver_now = false;
            }

            if (response.data.deliver_later == 1) {
                response.data.deliver_later = true;
            } else {
                response.data.deliver_later = false;
            }

            if (response.data.pickup_now == 1) {
                response.data.pickup_now = true;
            } else {
                response.data.pickup_now = false;
            }

            if (response.data.pickup_later == 1) {
                response.data.pickup_later = true;
            } else {
                response.data.pickup_later = false;
            }

            if (response.data.deliver_later_type == null) {
                response.data.deliver_later_type = "days";
            }

            if (response.data.deliver_later_value == null) {
                response.data.deliver_later_value = 1;
            }

            if (response.data.pickup_later_type == null) {
                response.data.pickup_later_type = "days";
            }

            if (response.data.pickup_later_value == null) {
                response.data.pickup_later_value = 1;
            }

            commit(
                "setOriginalDeliveryBaseValue",
                response.data.delivery_base_value
            );
            commit("setOriginalFeatureBrand", response.data.feature_brand);
            commit("setAdvanceSettings", response.data);
            commit("reset");
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },
    async updateAdvanceSettings({ commit }, param) {
        commit("loading", true);
        try {
            let response = await branches.updateAdvanceSettings(
                param.uuid,
                param.payload
            );

            if (router.currentRoute.name !== "onboarding")
                notification.success(response.message);

            commit("reset");
        } catch (errors) {
            notification.warning("Oops, cannot update settings.");
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    }
};

export default {
    namespaced: true,
    state: {
        options: [],
        branchOptions: [],
        branches: [],
        citiesByBrand: {},
        cities: [],
        loading: false,
        errors: {},
        view: {},
        created: false,
        updated: false,
        deleted: false,
        imported: false,
        branchTableList: [],
        advanceSettings: {},
        originalFeatureBrand: null,
        originalDeliveryBaseValue: 0,
        originalBranches: [],
        brandsAndBranches: [],
    },
    actions,
    mutations,
    getters
};
